export const TRANSACTION_TYPES = {
  brexPoints: 'brexPoints',
  nitraPoints: 'nitraPoints',
  creditCard: 'creditCard',
};

export const TRANSACTION_AMOUNT_TYPES = {
  points: 'points',
  nitraPoints: 'nitraPoints',
  brexPoints: 'brexPoints',
};

export const TRANSACTION_PURPOSE_TYPES = {
  savings: 'savings',
  refund: 'refund',
};

export enum ResourceTypes {
  blackbox = 'blackBox',
  agency = 'agency',
  organizations = 'organizations', 
  users = 'users',
  department = 'department',
  customerLogin = 'customerLogin',
  features = 'features',
  resource = 'resource',
  inventory = 'inventory',
  creditCards = 'creditCards', 
  travelers = 'travelers', 
  expenseReport = 'expenseReport',
  travelerResource = 'travelerResource',
  bookings = 'bookings',
  auditEvents = 'auditEvents',
  triggerJobs = 'triggerJobs',
}

export enum PermissionTypes {
  update = 'update',
  create = 'create',
  read = 'read',
  delete = 'delete',
  refund = 'refund',
  charge = 'charge',
};
